module.exports = __webpack_public_path__ + "img/checkout-success.97072576.svg";